<mat-form-field color="accent-darker" appearance="outline">
    <mat-label>{{Etiquetas.FilterPais}}</mat-label>
    <mat-select (selectionChange)="selectPais($event.value)">
        <mat-option [value]="-1">Todos</mat-option>
        <mat-option *ngFor="let p of paises" [value]="p.id">
            {{p.descripcion}}
        </mat-option>
    </mat-select>
</mat-form-field>